<template>
    <a-drawer
      :title="'发表论文-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="40%"
    >
        <div class="input-box">
            <p>发表或录用日期：</p>
            <a-date-picker class="input"  valueFormat="YYYY-MM-DD" v-model="info.publishDate" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>发表类别：</p>
            <a-select class="input" allowClear v-model="info.publishCategory" :disabled="actionName=='查看'">
                <a-select-option  value="已发表">已发表</a-select-option>
                <a-select-option  value="未发表">未发表</a-select-option>
                <a-select-option  value="已录用">已录用</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>最高分区：</p>
            <a-input class="input" v-model="info.highestPartition" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>本人排名：</p>
            <a-select class="input" allowClear v-model="info.selfRanking" :disabled="actionName=='查看'">
                <a-select-option  value="第一作者">第一作者</a-select-option>
                <a-select-option  value="导师第一，本人第二">导师第一，本人第二</a-select-option>
                <a-select-option  value="其他">其他</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>上海大学是否第一作者单位：</p>
            <a-select class="input" allowClear v-model="info.isIrshuFirstAuthorUnit" :disabled="actionName=='查看'">
                <a-select-option  :value="true">是</a-select-option>
                <a-select-option  :value="false">否</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>图书馆审核状态：</p>
            <a-select class="input" allowClear v-model="info.libraryReviewStatus" :disabled="actionName=='查看'">
                <a-select-option  value="未认定">未认定</a-select-option>
                <a-select-option  value="已认定">已认定</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>检索类型：</p>
            <a-select class="input" allowClear v-model="info.searchType" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in slsjkArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>

        </div>
        <div class="input-box">
            <p>期刊类型：</p>
            <a-input class="input" v-model="info.journalType" :disabled="actionName=='查看'"/>        
        </div>
        <div class="input-box">
            <p>论文题目（中文）：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.paperTitleChinese" />
        </div>
        <div class="input-box">
            <p>论文题目_英文：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.paperTitleEnglish" />
        </div>
        <div class="input-box">
            <p>期刊名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.journalName" />
        </div>
        <div class="input-box">
            <p>论文发表的学术刊物或会议名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.thesisName" />
        </div>
        <div class="input-box">
            <p>期刊号：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.journalNumber" />
        </div>
        <div class="input-box">
            <p>年卷期：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.annualVolumePeriod" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="draft" v-if="actionName!='查看'">暂存</a-button>
            <a-button type="primary" @click="commit" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { addPaper,getPaper,updatePaper } from '@/baseAPI/postdoctor'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                doctorId:'',
                info:{
                    id:"",
                    doctorId:"",
                    publishDate: "",
                    publishCategory: "",
                    highestPartition: "",
                    selfRanking: "",
                    isIrshuFirstAuthorUnit: null,
                    libraryReviewStatus: "",
                    searchType: "",
                    journalType: "",
                    paperTitleChinese: "",
                    paperTitleEnglish: "",
                    journalName: "",
                    thesisName: "",
                    journalNumber: "",
                    annualVolumePeriod: "",
                    approvalStatus:""
                },
                xmjbArr:[],
                jsArr:[],
                yearShowOne:false,
                slsjkArr:[]
            }
        },
        mounted () {
            getDicts({dataCode:'LWSLSJK',status:true}).then(res=>{
                this.slsjkArr=res.data.dicts;
            })
        },
        methods:{
            draft(){
                this.info.approvalStatus = 'draft'
                this.sub()
            },
            commit(){
                this.info.approvalStatus = 'commit'
                this.sub()
            },
            getInfo(){
                if(this.actionName!='新增'){
                    getPaper(this.doctorId).then(res=>{
                        res.data.forEach(element => {
                            if(element.id == this.id){
                                this.info = element;
                            }
                        });
                    })
                }
            },
            showDrawer(name,doctorId,id){
                this.id=id;
                this.doctorId = doctorId;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={}
                this.visible = false;
                this.$parent.getPaper()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                // console.log(this.info)
                // var arr=['remark','approvalStatus','courseAttrName']
                // for(let key in this.info){
                //     if(arr.indexOf(key)<0){
                //         if(this.info[key]==null||this.info[key]===''){
                //             isSub=false;
                //             break;
                //         }
                //     }
                // }
                if(isSub){
                    this.info.doctorId = this.doctorId;
                    if(this.actionName=='新增'){
                        addPaper(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增论文发表成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        updatePaper(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            openChangeOne(status) {
                if (status){
                    this.yearShowOne =  true
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            }

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 15rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 15rem);
    }
    .input-box .tips{
        width: calc(100% - 15rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
